var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-3" },
    [
      _c("span", {
        staticClass: "mr-1",
        domProps: { innerHTML: _vm._s(_vm.name) }
      }),
      _vm._v(" "),
      _vm.btnTitle
        ? _c(
            "base-button",
            {
              staticClass: "reduced-padding-btn",
              attrs: {
                backgroundColor: _vm.createdHabitId ? _vm.green : "",
                borderColor: _vm.createdHabitId ? _vm.green : ""
              },
              on: { click: _vm.showHabit }
            },
            [_vm._v(_vm._s(_vm.btnTitle))]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18e0e2b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18e0e2b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/HistoryHealthyHabitsItem.vue
// module id = 3969
// module chunks = 37